import { render } from "./MainLayout.vue?vue&type=template&id=198e7f5d"
import script from "./MainLayout.vue?vue&type=script&lang=js"
export * from "./MainLayout.vue?vue&type=script&lang=js"

import "./MainLayout.vue?vue&type=style&index=0&id=198e7f5d&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__